module.exports = __webpack_public_path__ + "img/FACEBOOK_Logo.51f9d736.svg";